import _actions_remove from './_actions/remove.js'
import _actions_reload from './_actions/reload.js'
import _actions_get from './_actions/get.js'
import _actions_change_sum from './_actions/change_sum.js'
import _actions_add from './_actions/add.js'
import _getters_sum from './_getters/sum.js'
import _getters_spreads from './_getters/spreads.js'
import _getters_regular from './_getters/regular.js'
import _getters_loading from './_getters/loading.js'
import _mutations_set_item from './_mutations/set_item.js'
import _mutations_set_form from './_mutations/set_form.js'
import _mutations_set_data from './_mutations/set_data.js'
import state from './_state/index.js'

export default {
    namespaced: true,
    state,
    mutations:{
        set_data: _mutations_set_data,
        set_form: _mutations_set_form,
        set_item: _mutations_set_item,
    },
    getters:{
        loading: _getters_loading,
        regular: _getters_regular,
        spreads: _getters_spreads,
        sum: _getters_sum,
    },
    actions:{
        add: _actions_add,
        change_sum: _actions_change_sum,
        get: _actions_get,
        reload: _actions_reload,
        remove: _actions_remove,
    },
}